<collapsible-card title="Customer Notes" [loading]="loading">
@if (error) {
  <error-message
    [page]="'Note Component'"
    [error]="noteErrorMessage">
  </error-message>
}
@if (!error) {
  <div fxLayout="column" fxLayoutAlign="start stretch">
    <button mat-raised-button
      fxFlexAlign="end"
      class="note-section__create-button"
      data-testid="create-note-button"
      [disabled]="disabledChanges"
      (click)="checkForUnsavedChanges(createNote)">
      {{createNoteText}}
    </button>
    @if (notes.length === 0) {
      <div class="note-section__no-results-text">
        {{noteNoResultsMessage}}
      </div>
    }
    @for (note of displayNotes; track note.noteId || (note.isNewNote ? ('new|' + $index) : ($index + '|' + note.updatedAt + '|' + note.updatedBy)); let i = $index) {
      <div
        class="note-section__note-container"
        [ngClass]="{'note-section__blue-background': i % 2 !== 0, 'note-section__note-top-border': i === 0}">
        <note [note]="note"
          [disableChanges]="disabledChanges"
          [subText]="subText"
          (editNoteClicked)="checkForUnsavedChanges(editNote, note)"
          (updateNoteText)="updateNoteText($event, note)"
          (cancelEditClicked)="checkForUnsavedChanges(cancelEdit, note)"
          (saveNoteClicked)="saveNote(note)"
          (deleteNoteClicked)="deleteNote(note)">
        </note>
      </div>
    }
    @if (notes.length > pageSize) {
      <pagination
        [totalElements]="notes.length"
        [pageSize]="pageSize"
        [currentPage]="currentPage"
        (pageLeft)="pageLeft()"
        (pageRight)="pageRight()">
      </pagination>
    }
  </div>
}
</collapsible-card>
